import { Component, Input } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "period-check-dialog",
  templateUrl: "./period-check-dialog.component.html",
  styleUrls: ["./period-check-dialog.component.scss"],
})
export class PeriodCheckDialogComponent {
  @Input() data: {
    eventTypeName: string;
  };
  constructor(protected ref: NbDialogRef<PeriodCheckDialogComponent>) {}

  close() {
    this.ref.close();
  }
}
